"use client";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import Icon from "./icon";
import { ButtonHTMLAttributes } from "react";

export interface RadioGroupProps extends RadixRadioGroup.RadioGroupProps {
  label: string;
  items: RadioGroupItem[];
  variant?: "default" | "subscription";
}

interface RadioGroupItem {
  id: string;
  label?: JSX.Element;
  value: string;
  team?: string;
}

function RadioGroup(props: RadioGroupProps) {
  return (
    <RadixRadioGroup.Root
      className="flex flex-col gap-2.5 w-full"
      aria-label={props.label}
      {...props}
    >
      {props.items.map((item, i) => (
        <>
          <RadixRadioGroup.Item
            key={i}
            className={`group flex gap-4 h-[4.625rem] items-center w-full p-4 rounded-lg border border-surface-500 focus:border-primary hover:cursor-pointer hover:border-primary data-[state=checked]:border-primary  ${
              props.variant === "subscription"
                ? "data-[state=checked]:bg-[#242424] data-[state=checked]:text-white"
                : ""
            }`}
            value={item.value}
            id={item.id}
          >
            <div className="flex bg-transparent p-0.5 border-[2px] border-surface-500 group-data-[state=checked]:border-primary rounded-full w-4 h-4 shrink-0">
              <RadixRadioGroup.Indicator className="flex bg-primary-300 rounded-full w-full h-full" />
            </div>
            <label
              className="flex flex-row justify-start items-center w-full text-title-lg-medium group-hover:cursor-pointer"
              htmlFor={item.id}
            >
              {item.label}
            </label>
          </RadixRadioGroup.Item>
        </>
      ))}
    </RadixRadioGroup.Root>
  );
}

interface RadioButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  children?: React.ReactNode;
}
function Button(props: RadioButtonProps) {
  return (
    <button className="flex items-center gap-4 p-4 border border-surface-500 hover:border-dark rounded-lg w-full h-[4.625rem]">
      {props.icon && <Icon name={props.icon} size="sm" className="fill-dark" />}
      <span className="text-title-lg-medium">{props.children}</span>
    </button>
  );
}

RadioGroup.Button = Button;
export default RadioGroup;
